import { esc } from "../domain/format.js";
import { ui } from "../app/store.js";

function toast(m) {
  const t = document.getElementById("toast");
  t.textContent = m;
  t.hidden = false;
  clearTimeout(toast.h);
  toast.h = setTimeout(() => (t.hidden = true), 2600);
}

const chip = (txt, c) => `<span class="chip c-${c}">${esc(txt)}</span>`;

const STATUS_C = {
  POSTED: "good",
  DRAFT: "warn",
  APPROVED: "acc",
  RELEASED: "good",
  PENDING: "warn",
  REJECTED: "bad",
  FILED: "good",
};

const ssn = (s) => chip(s, STATUS_C[s] || "mut");

const mask = (v, show) =>
  !show ? "••••" : !v ? '<span class="muted">Not on file</span>' : esc(v);

function seg(key, opts, val) {
  return `<div class="seg" role="tablist">${opts.map(([v, l]) => `<button role="tab" aria-selected="${v === val}" data-seg="${key}" data-val="${v}">${l}</button>`).join("")}</div>`;
}

const tile = (label, value, dot, go) =>
  `<${go ? `button class="tile" data-go="${go}"` : `div class="tile"`}><span class="top-r"><span class="dot ${dot || ""}"></span>${go ? `<span class="muted">›</span>` : ""}</span><span><span class="v" style="display:block">${value}</span><span class="lbl">${label}</span></span></${go ? "button" : "div"}>`;

const panel = (title, sub, action, body, id) =>
  `<section class="panel"${id ? ` id="${id}"` : ""}><div class="panel-h"><div><h2>${title}</h2>${sub ? `<span class="muted">${sub}</span>` : ""}</div><div class="row">${action || ""}</div></div>${body}</section>`;

const csvBtn = (id) =>
  `<button class="out" data-act="csv" data-id="${id}">Copy CSV</button>`;

const periodSeg = () =>
  seg(
    "per",
    [
      ["month", "This month"],
      ["last", "Last month"],
      ["year", "This year"],
    ],
    ui.per || "year",
  );

export {
  toast,
  chip,
  STATUS_C,
  ssn,
  mask,
  seg,
  tile,
  panel,
  csvBtn,
  periodSeg,
};
